module.exports = __webpack_public_path__ + "media/images/index-desc-stars-64b8ebc74c54d63c3a4ee92df4fbf1f9.svg";